var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShareIconBule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12 15.75H9.6C5.45042 15.75 1.84744 18.1877 0.0388681 21.7634C0.0131161 21.4291 0 21.0911 0 20.75C0 13.8465 5.37258 8.25 12 8.25V2L24 12L12 22V15.75Z",
    fill: "#006399"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIconBule);
export default __webpack_public_path__ + "static/media/Share_icon_bule.aabe9dd534ec3efda73a5fae39fd3c93.svg";
export { ForwardRef as ReactComponent };